/*
 * Copyright (C) 2020 Reciprocity, Inc - All Rights Reserved
 * Unauthorized use, copying, distribution, displaying, or public performance
 * of this file, via any medium, is strictly prohibited. All information
 * contained herein is proprietary and confidential and may not be shared
 * with any third party without the express written consent of Reciprocity, Inc.
 */

import Vue from 'vue';
import './showAll.scss';

export default {
  name: 'show-all',
  bind(el) {
    const showAllLink = document.createElement('a');
    showAllLink.href = '#';
    showAllLink.className = 'show-link';

    const showAllMask = new Vue({
      el: showAllLink,
    });

    el.instance = showAllMask;
    el.mask = showAllMask.$el;
    el.appendChild(el.mask);
  },

  inserted(el, binding, vnode) {
    el.mask.addEventListener('click', e => {
      el.classList.toggle('parent__showall');
      el.mask.classList.toggle('less');
      const eventName = 'toggle';
      if (binding.modifiers.bubble) {
        vnode.context.$emit(eventName, e);
      } else {
        if (vnode.componentInstance) {
          // vue component
          vnode.componentInstance.$emit(eventName, e);
        } else {
          // regular dom (div)
          vnode.elm.dispatchEvent(new Event(eventName, e));
        }
      }
    });
    if (isOverflown(el)) {
      el.mask.classList.add('all');
    }
  },

  componentUpdated(el) {
    if (isOverflown(el)) {
      el.mask.classList.add('all');
    }
  },

  unbind(el) {
    if (!el.domInserted) return;
    el.mask && el.mask.parentNode && el.mask.parentNode.removeChild(el.mask);
  },
};

function isOverflown(element) {
  return element.scrollHeight > element.clientHeight;
}
